// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDwQeAPmvh0f9y7wM0nb955GgRtRdOE-78",
    authDomain: "tomasordonezg-portfolio.firebaseapp.com",
    projectId: "tomasordonezg-portfolio",
    storageBucket: "tomasordonezg-portfolio.appspot.com",
    messagingSenderId: "728631488794",
    appId: "1:728631488794:web:a1e54a85fc7fb41fae7ca3",
    measurementId: "G-444Q0NQH0Z",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);
const db = getDatabase(app);

export { analytics, storage, db };
